var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconValueLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.902 7.71875H1.14782C0.481619 7.76295 -0.0274737 8.33087 0.00115005 8.99792V17.1579C-0.0274737 17.825 0.481619 18.3929 1.14782 18.4371H12.902C13.5682 18.3929 14.0773 17.825 14.0486 17.1579V8.99792C14.0777 8.33071 13.5684 7.76252 12.902 7.71875ZM8.49115 15.5912H5.58448L6.15782 13.2979C5.79227 13.0221 5.57947 12.5891 5.58448 12.1312C5.58448 11.3152 6.24598 10.6537 7.06198 10.6537C7.87798 10.6537 8.53948 11.3152 8.53948 12.1312C8.5437 12.606 8.31243 13.052 7.92198 13.3221L8.49115 15.5912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97028 5.20458V5.20458C3.97028 3.5116 5.34272 2.13917 7.0357 2.13917C8.72868 2.13917 10.1011 3.5116 10.1011 5.20458V5.20458V6.85875H12.2619V5.20458V5.20458C12.2619 3.34516 11.27 1.62699 9.65966 0.697282C8.04935 -0.232427 6.06538 -0.232427 4.45507 0.697282C2.84477 1.62699 1.85278 3.34516 1.85278 5.20458V5.20458V6.85875H4.01362L3.97028 5.20458Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValueLocked);
export default __webpack_public_path__ + "static/media/icon-value-locked.90c93c30.svg";
export { ForwardRef as ReactComponent };